import styled from "styled-components";

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  padding: 0 24px;
  background-color: #FAFAFA;
`;

export const Header = styled.div`
  padding: 32px 0 24px;
  text-align: center;
`;

export const Title = styled.h1`
  font-size: 22px;
  font-weight: 700;
  color: #000;
  margin: 0;
`;

export const ContentWrap = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 100px;
`;

export const IconContainer = styled.div`
  margin-bottom: 40px;
`;

export const CongratsIcon = styled.img`
  width: 120px;
  height: 120px;
  object-fit: contain;
`;

export const MessageContainer = styled.div`
  text-align: center;
  margin-bottom: 16px;
`;

export const MainMessage = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: #000;
  margin: 0 0 16px 0;
`;

export const SubMessage = styled.p`
  font-size: 15px;
  font-weight: 400;
  color: #666;
  line-height: 1.6;
  margin: 0;
`;

export const BottomButton = styled.button`
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 48px);
  max-width: 432px;
  height: 52px;
  border: none;
  font-weight: 600;
  font-size: 16px;
  background-color: #1FBC70;
  border-radius: 12px;
  color: white;
  cursor: pointer;

  &:hover {
    background-color: #18a860;
  }

  &:active {
    background-color: #159150;
  }
`;
